import { allModules } from "../../constants/contact"

const titles = ['內容', '形式']

const getContactSections = ({ template, templateConfig }) => {
  if (!templateConfig) {
    return allModules.slice(0, 3).map(section => ({
      ...section,
      steps: section.steps.map((step, index) => ({
        ...step,
        options: step.options.filter(opt => {
          const cfg = templateConfig?.[section.key]?.[index]?.[opt]
          return typeof cfg === 'undefined' || cfg
        })
      }))
    }))
  }
  return templateConfig.map(({ key, steps }) => {
    const found = allModules.find(section => section.key === key)
    return {
      ...found,
      steps: steps.map((options, index) => ({
        title: titles[index],
        options,
      })),
    }
  })
}

export default getContactSections
